import { requestApi, API_END_POINT } from '../../common/api';
import { RESULT_CODE, LOGOUTPUT_ACTIONS } from '../../common/const';
import { setErrorMessage } from './CommonAction';

/**
 * state初期化のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INIT_LOG_OUTPUT_STATE = 'LOG/SET_INIT_LOG_OUTPUT_STATE';
/**
 * state初期化
 */
export const setInitLogOutputState = () => ({
  type: SET_INIT_LOG_OUTPUT_STATE,
});

/**
 * 選択された年月のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TARGET_YM = 'LOG/SET_TARGET_YM';
/**
 * 選択された年月
 * @type    {string}  選択対象
 */
export const setTargetYM = (targetYM) => ({
  type: SET_TARGET_YM, targetYM,
});

/**
 * 選択された機能のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TARGET_FUNC = 'LOG/SET_TARGET_FUNC';
/**
 * 選択された機能
 * @type    {string}  選択対象
 */
export const setTargetFunc = (targetFunc) => ({
  type: SET_TARGET_FUNC, targetFunc,
});

/**
 * アクセスログのAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ACCESS_LOG = 'LOG/SET_ACCESS_LOG';
/**
 * アクセスログ
 * @type    {object}  アクセスログリスト
 */
export const setAccessLog = (accessLog) => ({
  type: SET_ACCESS_LOG, accessLog,
});

/**
 * 表示用アクセスログのAction識別文字列
 * @type    {object}  Action識別文字列
 */
export const SET_DISP_ACCESS_LOG = 'LOG/SET_DISP_ACCESS_LOG';
/**
 * 表示用アクセスログ
 * @type    {object}  表示用アクセスログリスト
 */
export const setDispAccessLog = (dispAccessLog) => ({
  type: SET_DISP_ACCESS_LOG, dispAccessLog,
});

/**
 * 対象年月リスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_TARGET_DATE_LIST = 'LOG/SET_TARGET_DATE_LIST';

/**
 * 対象年月リスト設定
 * @param   {string[]}  targetList 権限リスト
 */
export const setTargetList = (targetList) => ({
  type: SET_TARGET_DATE_LIST, targetList,
});

/**
 * 機能リスト設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ROLE_LIST = 'LOG/SET_ROLE_LIST';

/**
 * 機能リスト設定
 * @param   {string[]}  roleList 権限リスト
 */
export const setRoleList = (roleList) => ({
  type: SET_ROLE_LIST, roleList,
});

/**
 * アクセスログ取得処理
 * @param {*} targetDate 選択された対象年月
 * @param {*} action 選択された機能
 * @returns boolean
 */
export const getAccessLog = () => async (dispatch, getState) => {
  const {
    targetYM,
    targetFunc,
  } = getState().logoutput;
  // リクエストパラメータ生成
  const o = {
    access_date: targetYM,
  };
  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.LOG_OUTPUT_CHART_DATA, o);

  // 取得件数0件の場合、一覧を空にする
  if (ret.result === RESULT_CODE.NOT_FOUND) {
    dispatch(setAccessLog({}));
    dispatch(setDispAccessLog({}));
    return true;
  }
  // エラーの場合、メッセージを設定し一覧を空にする
  if (ret.result !== RESULT_CODE.SUCCESS) {
    dispatch(setErrorMessage(ret.response));
    dispatch(setAccessLog({}));
    dispatch(setDispAccessLog({}));
    return false;
  }

  // 検索結果を保存
  const accessLog = [];
  ret.response.list.map((v) => {
    const item = {
      date: v.date,
      ...v.access_count,
    };
    accessLog.push(item);
    return null;
  });
  dispatch(setAccessLog(accessLog));

  if (!LOGOUTPUT_ACTIONS[targetFunc]) {
    setTargetFunc(LOGOUTPUT_ACTIONS.ALL);
  }

  // 機能が選択されている場合はフィルタリング
  const dispAccessLog = [];
  accessLog.forEach((v) => {
    if (targetFunc === LOGOUTPUT_ACTIONS.ALL) {
      dispAccessLog.push(v);
    } else {
      const item = {
        date: v.date,
        [targetFunc]: v[targetFunc],
      };
      dispAccessLog.push(item);
    }
  });
  dispatch(setDispAccessLog(dispAccessLog));
  return true;
};

/**
 * アクセスログファイル取得
 * @param {*} targetDate 選択された対象年月
 * @param {*} action 選択された機能
 * @returns boolean
 */
export const executeFileDownload = (targetDate, action) => async (dispatch) => {
  // リクエストパラメータ生成
  const o = {
    access_date: targetDate,
    action,
  };
  // 検索実行
  const ret = await requestApi(dispatch, API_END_POINT.LOG_OUTPUT_DONWLOAD, o, false, true);
  if (ret.result !== RESULT_CODE.SUCCESS) {
    // エラーが発生した場合、エラーメッセージを表示
    dispatch(setErrorMessage(ret.response));
    return false;
  }
  // ダウンロード処理
  let actionName = '';
  Object.keys(LOGOUTPUT_ACTIONS).forEach((v) => {
    if (action === LOGOUTPUT_ACTIONS[v]) {
      actionName = v.toLocaleLowerCase().concat('_');
    }
  });

  const downLoadLink = document.createElement('a');
  document.body.appendChild(downLoadLink);
  downLoadLink.download = 'usage_'.concat(actionName) + targetDate.replace('/', '').concat('.csv');
  downLoadLink.href = window.URL.createObjectURL(ret.response);
  downLoadLink.click();

  return true;
};
